import script from "./VitaMainTableHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaMainTableHead.vue?vue&type=script&lang=ts&setup=true"

import "./VitaMainTableHead.vue?vue&type=style&index=0&id=64c2d06c&lang=scss"

const __exports__ = script;

export default __exports__